var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomButton',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'CustomButton',_vm.$props,false),[(_vm.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }